import React, {useState} from 'react';
import mobile from "../assets/tetherbet-banner_mobile-mbappe.png";
import lg from "../assets/tetherbet-banner-mbappe.png";
import register from "../assets/register.png";
import usecode from "../assets/useCode.png";

function Main() {


    const [isTextVisible, setIsTextVisible] = useState(false);
    const onClick = () => {
        setIsTextVisible(!isTextVisible)
    }


    return (
        <div className="flex flex-col   mt-3 ">
            <div
                className="">
                <img src={lg} alt="Euro 2024 banner" className="max-w-full hidden xl:block object-cover "/>
                <img src={mobile} alt="Euro 2024 banner for mobile" className="w-full xl:hidden object-cover"/>
            </div>
            <div className="max-w-[800px] mx-auto  px-5 flex flex-col justify-center items-center mt-10 md:mt-20 ">

                <div className="text-start flex flex-col items-start  text-[#F0F0F0]">

                    <h1 className="font-bold text-xl md:text-2xl mb-5 mx-auto ">Mbappé’s Debut</h1>
                    <p className=" font-bold text-base md:text-xl ">Every Mbappé Goal Brings You Free Bets! Bet on Real
                        Madrid Today!
                    </p>


                    <h2 className="font-bold text-xl md:text-2xl mt-10 md:mt-20 mb-5"> Promotion Details
                    </h2>
                    <p className=" text-sm md:text-lg  ">
                        <span className="font-bold">Event:</span> Real Madrid - Atalanta
                    </p>
                    <p className=" text-sm md:text-lg  ">
                        <span className="font-bold">Offer:</span> Earn 10 USDT in free bets for each goal Kylian Mbappé
                        scores in a match if Real Madrid wins
                    </p>
                    <p className=" text-sm md:text-lg  ">
                        <span className="font-bold">Qualifying Bet:</span> Place a pre-match single bet of at least 20
                        USDT on Real Madrid (1x2 market)
                    </p>

                    <div className="w-full my-10 md:my-16 ">
                        <a
                            href="https://tether.bet/?sign-up=true"
                            className=""
                        >
                            <img
                                src={register}
                                alt="Tether Triton Banner"
                                className="w-full h-auto object-cover"
                            />
                        </a>
                    </div>

                    <p className=" font-bold text-sm md:text-lg  ">Have you got questions? Contact our customer support
                        via live chat or email us at support@tether.bet.
                    </p>


                    <button className=" bg-[#313131] text-[#B6B6B6] py-2 px-10 rounded-md hover:text-white my-8"
                            onClick={onClick}>{isTextVisible ? 'Hide Terms & Conditions' : 'Show Terms & Conditions'} </button>
                    {isTextVisible && <Text/>}


                </div>
            </div>
        </div>
    );
}

const Text = () => <div><p className="md:leading-10 text-sm md:text-base  mb-10 "><br/>
    - This promotion is open to all registered users of tether.bet.<br/>
    - Only the first bet placed on Real Madrid - Atalanta match is eligible for this promotion.
    <br/>
    - One bet per user, per match, per household.
    <br/>
    - Earn 10 USDT in free bets for each goal Kylian Mbappé scores in a match if Real Madrid wins.
    <br/>
    -Free bets will be credited within 24 hours after the match ends.
    <br/>
    -The maximum amount you can win from free bets is 10,000 USDT (or a currency equivalent).<br/>
    - The stake from a free bet is not included in your return.<br/>
    - Bets placed with bonus funds or free bet tokens do not qualify for this promotion.
    <br/>
    - To cash out your bonus, you need to roll it over at least once at odds of 2.00 or higher.
    <br/>
    - Cashed-out and void bets do not qualify for the promotion.<br/>
    - Free bet must be used within 7 days from the date of receipt. <br/>
    - If the match is cancelled or postponed, the promotion is void. <br/>
    - If there is any evidence of a series of bets placed by a customer or a group of customers that results in
    guaranteed profits regardless of the outcome, tether.bet reserves the right to reclaim the bonus and ask for
    documentation to verify the client's identity before granting any bonus. <br/>
    - tether.bet reserves the right to modify, suspend, or terminate the promotion at any time without prior notice. <br/>
    - tether.bet management’s decision is final in all matters relating to this promotion.


</p></div>;

export default Main;